import * as React from "react"
import {Navigate, Route, Routes} from "react-router-dom";

import MemberPage from "./member/MemberPage";
import {ROUTES} from "../helpers/constants";
import LibraryPage from "./eLibrary/LibraryPage";
import DownloadsPage from "./downloads/DownloadsPage";
import LoginPage from "./login/LoginPage";
import RequireAuth from "./login/RequireAuth";
import UnsubscribePage from "./unsubscribe/UnsubscribePage";
import MeetingScheduler from "./member/MeetingScheduler";
import AppointmentsPage from "./member/AppointmentsPage";
import QuizListPage from "./quiz/QuizListPage";
import QuizPage from "./quiz/QuizPage";

const Content = () => {
  const hasProductHeader = document.pageInfo ? !!document.pageInfo.hasProductHeader : false;

  return (
    <Routes>
      <Route path={ROUTES.home} element={hasProductHeader ? <Navigate to={ROUTES.eLibrary} replace /> : <RequireAuth><MemberPage/></RequireAuth>}  />
      <Route path={ROUTES.eLibrary} element={<RequireAuth><LibraryPage/></RequireAuth>}  />
      <Route path={ROUTES.downloads} element={<RequireAuth><DownloadsPage/></RequireAuth>}  />
      <Route path={ROUTES.schedule} element={<RequireAuth><MeetingScheduler/></RequireAuth>}  />
      <Route path={ROUTES.appointments} element={<RequireAuth><AppointmentsPage/></RequireAuth>}  />
      <Route path={ROUTES.tests} element={<RequireAuth><QuizListPage/></RequireAuth>}  />
      <Route path={ROUTES.testsQuiz} element={<RequireAuth><QuizPage/></RequireAuth>}  />
      <Route path={ROUTES.login} element={<LoginPage/>} />
      <Route path={ROUTES.restore} element={<LoginPage/>} />
      <Route path={ROUTES.unsubscribe} element={<UnsubscribePage/>} />
      <Route path={ROUTES.unsubscribeSuccess} element={<UnsubscribePage/>} />
    </Routes>
  )
}

export default Content
